import React from 'react'
import {connect} from "react-redux";
import PropTypes from "prop-types";

const SqftContextMenuV2 = (props) => {
  const {isOpened, title, menuItems, position} = props;

  return (
    <div className={"contextmenu2 " + (isOpened ? "" : "hidden")}
         style={{left: position.left + 'px', top: position.top + 'px'}}>
      <div className="contextmenu2-title">
        {title}
      </div>
      <div className="menu-items">
        {
          menuItems.map((item, index) => {
            return <div key={index}>
              {item.title}
            </div>
          })
        }
      </div>
    </div>
  )
};

SqftContextMenuV2.propTypes = {
  isOpened: PropTypes.bool,
  title: PropTypes.string,
  menuItems: PropTypes.array,
  position: PropTypes.object,
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(SqftContextMenuV2);
